import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pushSection } from './AccordionActions';

export class Accordion extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired, // Must contain exclusively AccordionSections
        initialize: PropTypes.func.isRequired,

        // Passed in props
        initialExpandedIndices: PropTypes.arrayOf(PropTypes.number)
    };

    static defaultProps = {
        initialExpandedIndices: [-1]
    };

    constructor(props) {
        super(props);

        const { children, initialize, initialExpandedIndices } = props;
        initialize(children, initialExpandedIndices);
    }

    render() {
        return (
            <div className="Accordion">
                {this.props.children}
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    initialize(children, initialExpandedIndices) {
        Children.forEach(children, (child, i) => {
            dispatch(pushSection(child.props.id, initialExpandedIndices.indexOf(i) > -1));
        });
    }
});

export default connect(() => ({}), mapDispatchToProps)(Accordion);
